export const selectIsSend = state => state.auth.isSent;
export const selectEmail = state => state.auth.user.email;
export const selectIsLoading = state => state.auth.isLoading;
